import { NgFor, NgIf, UpperCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { Ga4Service } from '@vaki/shared/util/ga4';
import { NewWindowDirective } from '@vaki/shared/util/front-end';
import {
  CurrencySymbol,
  GA4ClickEvents,
  Language
} from '@vaki/shared/util/interfaces';
import {
  FOOTER_COLUMN_1,
  FOOTER_COLUMN_2,
  FOOTER_COLUMN_3,
  LOGO_FOOTER
} from './../config';

@Component({
  selector: 'lib-vakers-shell-ui-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatListModule,
    NgFor,
    NewWindowDirective,
    NgIf,
    RouterLink,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    UpperCasePipe
  ],
  templateUrl: './vakers-shell-ui-footer.component.html',
  styleUrl: './vakers-shell-ui-footer.component.scss'
})
export class VakersShellUiFooterComponent {
  @Input() languages: Language[] | undefined;
  @Input() currentLanguage: string | undefined | null;
  @Output() languageSelected = new EventEmitter<string>();
  @Input() currencies: CurrencySymbol[] | null = [];
  @Input() currentCurrency: string | null = null;
  @Output() currencySelected = new EventEmitter<CurrencySymbol>();
  readonly currentYear = new Date().getFullYear();
  readonly ga4ClickEvents = GA4ClickEvents;
  public readonly ga4Service: Ga4Service = inject(Ga4Service);

  logo = LOGO_FOOTER;
  columnOneNavLinks = FOOTER_COLUMN_1;
  columnTwoNavLinks = FOOTER_COLUMN_2;
  columnThreeNavLinks = FOOTER_COLUMN_3;
}
